export const NAMESPACE = 'mavis';
export const STORE_NAME = 'mavis';
export const FILTER_NAMESPACE = STORE_NAME;
export const I18N_DOMAIN = 'mavis';
